module.exports = __webpack_public_path__ + "static/2-003-1309f20beed3c1e256a8342bcb54cfd8.jpg";